var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "influencer_levels.create",
              expression: "'influencer_levels.create'",
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { 400: true },
            },
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew },
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" },
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew"))),
          ]),
        ],
        1
      ),
      _c("Grid", {
        attrs: {
          service: _vm.service,
          route_name: "influencer_levels",
          order_column: "rank",
        },
        scopedSlots: _vm._u([
          {
            key: "gridThead",
            fn: function () {
              return [
                _c("vs-th", { key: "id", attrs: { "sort-key": "id" } }, [
                  _vm._v("ID"),
                ]),
                _c("vs-th", { key: "rank", attrs: { "sort-key": "rank" } }, [
                  _vm._v(_vm._s(_vm.$t("influencer_level.rank"))),
                ]),
                _c("vs-th", { key: "name", attrs: { "sort-key": "name" } }, [
                  _vm._v(_vm._s(_vm.$t("influencer_level.name"))),
                ]),
                _c("vs-th", { key: "requirements" }, [
                  _vm._v(_vm._s(_vm.$t("influencer_level.requirements"))),
                ]),
                _c("vs-th", { key: "bonus" }, [
                  _vm._v(_vm._s(_vm.$t("influencer_level.bonus"))),
                ]),
                _c(
                  "vs-th",
                  { key: "status", attrs: { "sort-key": "status" } },
                  [_vm._v(_vm._s(_vm.$t("influencer_level.status")))]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "gridData",
            fn: function (props) {
              return _vm._l(props.data, function (tr, indextr) {
                return _c(
                  "vs-tr",
                  { key: indextr, attrs: { data: tr } },
                  [
                    _c("vs-td", { key: "id", attrs: { width: "5%" } }, [
                      _vm._v(_vm._s(tr.id)),
                    ]),
                    _c("vs-td", { key: "rank", attrs: { width: "8%" } }, [
                      _vm._v(_vm._s(tr.rank)),
                    ]),
                    _c(
                      "vs-td",
                      { key: "name", attrs: { width: "22%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            attrs: {
                              transparent: "",
                              color: tr.badge_color || "primary",
                            },
                          },
                          [_vm._v(_vm._s(tr.name))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "vs-td",
                      { key: "requirements", attrs: { width: "35%" } },
                      [
                        _c("small", { staticClass: "text-muted" }, [
                          _vm._v(_vm._s(_vm.requirementsLabel(tr))),
                        ]),
                      ]
                    ),
                    _c("vs-td", { key: "bonus", attrs: { width: "12%" } }, [
                      _vm._v(
                        "+" + _vm._s(Number(tr.commission_bonus_pct || 0)) + "%"
                      ),
                    ]),
                    _c(
                      "vs-td",
                      { key: "status", attrs: { width: "10%" } },
                      [
                        _c(
                          "vs-chip",
                          {
                            attrs: {
                              transparent: "",
                              color: tr.status === "AC" ? "success" : "warning",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  tr.status === "AC"
                                    ? _vm.$t("active")
                                    : _vm.$t("inactive")
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c("vs-td", { attrs: { width: "8%" } }, [
                      _c(
                        "div",
                        { staticClass: "flex flex-row gap-2" },
                        [
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "influencer_levels.edit",
                                expression: "'influencer_levels.edit'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                            attrs: { icon: "EditIcon" },
                            on: {
                              click: function ($event) {
                                return props.edit(props.data[indextr].id)
                              },
                            },
                          }),
                          _c("feather-icon", {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "influencer_levels.delete",
                                expression: "'influencer_levels.delete'",
                              },
                            ],
                            staticClass:
                              "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                            attrs: { icon: "Trash2Icon" },
                            on: {
                              click: function ($event) {
                                return props.destroy(props.data[indextr])
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }